import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/portfolios',
    name: 'portfolios',
    component: () => import(/* webpackChunkName: "ctx-portfolios" */ './Portfolios.vue'),
    meta: {
        role: Role.USER,
        license: [],
        authenticated: true,
        navbar: true,
        footer: true,
        settingsTabs: true,
        settingsTabsOrder: 1,
        portfolioTabs: false,
        onboarding: true,
        notifications: true,
    },
};

export { route };
